import * as React from 'react';

import { Button } from '@cian/button-component';

import { IGetFavoriteEntitiesParameters } from '../../actions/favoriteEntities';
import { IResultsState, EGetFavoriteEntitiesStatus } from '../../types/results';

import * as styles from './Pagination.css';

export interface IPaginationStoreProps {
  results: IResultsState;
}

export interface IPaginationDispatchProps {
  getFavoriteEntities(parameters: IGetFavoriteEntitiesParameters): void;
}

export type TPagination = IPaginationStoreProps & IPaginationDispatchProps;

export function Pagination({ getFavoriteEntities, results }: TPagination) {
  const { status, favoriteEntities, hasMore } = results;

  if (!hasMore || !favoriteEntities.length) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <Button
        type="button"
        onClick={() => getFavoriteEntities({ offset: favoriteEntities.length, next: true })}
        isSync={status === EGetFavoriteEntitiesStatus.NextPageLoading}
      >
        Показать ещё
      </Button>
    </div>
  );
}
